// =============================================================================
// SimSense Platform — Legal Page Shell
// =============================================================================

import { useEffect } from "react";
import "./LegalPage.css";

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  useEffect(() => {
    document.title = `${title} | SimSense`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="legal-page">
      <div className="legal-page__header">
        <h1>{title}</h1>
        <p className="legal-page__date">Last Updated: {lastUpdated}</p>
      </div>
      <div className="legal-page__content">
        {children}
      </div>
    </div>
  );
}

export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="legal-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export function SubSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="legal-subsection">
      <h3>{title}</h3>
      {children}
    </div>
  );
}
